import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label"]

  updateLabel() {
    if (!this.hasInputTarget || !this.hasLabelTarget) return
    const file = this.inputTarget.files?.[0]
    this.labelTarget.textContent = file ? file.name : "No file selected"
  }
}
